export default "__VITE_ASSET__t_Ax8BWC__"